module.exports = __webpack_public_path__ + "media/images/NewMBD-dc6dd686aece8e8b2bdf7ff9b3cd95fa.png";